module.exports = __webpack_public_path__ + "static/media/main.010d53a6.png";